<template>
  <v-card class="wrapper table-wrapper pa-0 ma-0">
    <iframe
      ref="integratorFrame"
      :src="iframeSrc"
      class="integrator-frame"
      frameborder="0"
      title="AbrIron Integrator"
      allow="clipboard-read; clipboard-write"
    />
  </v-card>
</template>

<script>
export default {
  name: "integrator",
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  computed: {
    iframeSrc() {
      const token =
        JSON.parse(localStorage.getItem("token") || "{}").token || "";
      return `https://integrator.abriron.com/customer-panel/${this.path}#token=${encodeURIComponent(token)}`;
    },
  },
  mounted() {
    document.documentElement.classList.add("ai-cfo-no-page-scroll");
    document.body.classList.add("ai-cfo-no-page-scroll");
  },
  beforeDestroy() {
    document.documentElement.classList.remove("ai-cfo-no-page-scroll");
    document.body.classList.remove("ai-cfo-no-page-scroll");
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
  overflow: hidden;
}
.integrator-frame {
  width: 100%;
  height: 100% !important;
  min-height: 0 !important;
  border: 0;
  display: block;
}
.table-wrapper {
  min-height: 300px;
}
</style>
